import { SettingsPanelActionTypes, SettingsPanelState, SET_KEYS } from "./types";

const initialSettingsPanelState: SettingsPanelState = {
  setSettingsPanelActiveKeys: ["1"]
};

export const settingsPanelReducer = (
  state = initialSettingsPanelState,
  action: SettingsPanelActionTypes
): SettingsPanelState => {
  switch (action.type) {
    case SET_KEYS:
      return {
        setSettingsPanelActiveKeys: action.meta.params.setSettingsPanelActiveKeys
      };
    default:
      return state;
  }
};
